import RouteResponse from '@/RouteResponse';
import Axios, { AxiosResponse } from 'axios';
import _ from 'lodash';
import { Coordinate, equals } from 'ol/coordinate';
import { offset } from 'ol/sphere';
import CoordHelper from './CoordHelper';
import NearestResponse from './NearestResponse';
import regions from './regions';
import { LineString as geojsonLineString } from 'geojson'

export class RouterError extends Error {
    isUserError = true
    constructor(msg: string) {
        super(msg)
    }
}

export class RouterStatic {
    i=0
    public async route(coords: Coordinate[], routerUrl: string): Promise<AxiosResponse<RouteResponse>> {
        const normalizedCoords = coords.map(c => CoordHelper.normalizeCoord(c))
        const offsets = _.uniq(normalizedCoords.map(n => n.offset))
        if(offsets.length > 1) {
            // tried to route across international date line.
            // even if the start and end fit inside one 'band' of the routing engine
            // it'll return 'NoRoute' anyway, as there is no cycle path from russia to alaska.
            throw new RouterError('Cannot create a route between these points. Try routing across a smaller area.')
        }
        const offsetToUse = offsets[0]
        let url = await regions.getUrl(normalizedCoords.map(n => n.coord), routerUrl);
        if(!url) {
            console.error('no route url for coords ', coords)
            throw new Error('no nearest url')
        }

        if(!url.endsWith("/")) {
            url += "/"
        }

        const coordsToUse = normalizedCoords.map(n => n.coord)
        for(let i = 0; i < coordsToUse.length; i++) {
            if(i > 0) url += ";";
            url += coordsToUse[i][0] + "," + coordsToUse[i][1];
        }
        url += "?geometries=geojson&overview=full";
        return Axios.get<RouteResponse>(url).then(r => {
            r.data.routes.forEach(route => {
                const geometry = route.geometry as geojsonLineString
                geometry.coordinates.forEach(c => c[0] -= offsetToUse) // necessary if we've panned across the international date line. coords can be < -180.
                for(let i = geometry.coordinates.length - 1; i > 0; i--) {
                    if(equals(geometry.coordinates[i -1], geometry.coordinates[i]) && geometry.coordinates.length > 2) {
                        geometry.coordinates.splice(i, 1)
                    }
                }
                return route
            })
            return r
        });
    }

    public async nearest(coordInput: Coordinate, routerUrl: string): Promise<AxiosResponse<NearestResponse>> {
        const normalized = CoordHelper.normalizeCoord(coordInput)
        let url = await regions.getNearestUrl(normalized.coord, routerUrl);
        if(!url) {
            console.error('no nearest url for coord ', normalized.coord)
            throw new Error('no nearest url')
        }

        if(!url.endsWith("/")) {
            url += "/"
        }

        url += normalized.coord[0] + "," + normalized.coord[1];
        url += ".json"; // also takes ?number=n (number of results to return, but default is 1, which we want)
        return Axios.get<NearestResponse>(url).then(nr => {
            nr.data.waypoints.forEach(wp => {
                wp.location[0] -= normalized.offset
            })
            return nr
        });
    }
}

const router = new RouterStatic();
export default router;
